// src/services/storageWorkerService.js
// A singleton wrapper around public/workers/metrics.worker.js
// ─────────────────────────────────────────────────────────────
import { createWorkerRequestService } from "./workerRequestService";

// Bump when metrics.worker.js output shape or logic changes. Production nginx
// long-caches *.js; without a version query, users can keep a stale worker while
// the main bundle updates (missing fields → NaN in UI). nginx now sends
// no-cache for workers, so this is belt-and-braces rather than the only
// defence -- kept because a stale worker is silent and hard to diagnose.
const METRICS_WORKER_VERSION = "6";

/* Export one shared instance */
export default createWorkerRequestService({
  scriptPath: "/workers/metrics.worker.js",
  requestIdPrefix: "storage",
  legacyResultType: "PER_DEVICE_RESULT",
  version: METRICS_WORKER_VERSION,
});
